import { defineMessages } from 'react-intl';

export default defineMessages({
    licenseNumber: {
        id: 'agency.admin.views.messages.licenseNumber',
        defaultMessage: 'TDI License Number: '
    },
    primaryLocation: {
        id: 'agency.admin.views.messages.primaryLocation',
        defaultMessage: 'Primary Location Address: '
    },
    mailingAddress: {
        id: 'agency.admin.views.messages.mailingAddress',
        defaultMessage: 'Mailing Address: '
    },
    primaryContact: {
        id: 'agency.admin.views.messages.primaryContact',
        defaultMessage: 'Primary Contact: '
    },
    directDeposit: {
        id: 'agency.admin.views.messages.directDeposit',
        defaultMessage: 'Direct Deposit: '
    },
    depositApprovalPending: {
        id: 'agency.admin.views.messages.depositApprovalPending',
        defaultMessage: 'Recent bank account details change is pending approval'
    }
});